/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconCentrelink extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "CentrelinkIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' viewbox="0 0 64.19 64" xmlns="http://www.w3.org/2000/svg"><g><rect height="64" fill="none" width="64"></rect><polyline points="49.75 19.69 26.11 11.42 5.03 22.4 6.91 62.28 24.4 61.22 23.58 47.77 33.32 47.18 34.14 60.63 51.63 59.57 49.75 19.69" fill="#d2cbcf"></polyline><path d="M45.79,1.72a18.75,18.75,0,0,0-2.14.13l-3,7.58L32.82,7a18.57,18.57,0,0,0-2.66,3.3L32,13.47l17.78,6.22.78,16.61L52,37.65a18.42,18.42,0,0,0,3.66-1.78L55,27.47,63.3,26.2a18.41,18.41,0,0,0,.89-4l-6.87-4.7,4.1-7.13A18.6,18.6,0,0,0,58.76,7l-7.84,2.4-3-7.58a18.75,18.75,0,0,0-2.14-.13" fill="#70bf73"></path><path d="M32,13.47l2.29,4-6.87,4.7a18.39,18.39,0,0,0,.89,4l8.26,1.26-.61,8.41a18.43,18.43,0,0,0,3.66,1.78l6.2-5.73,4.74,4.38-.78-16.61L32,13.47" fill="#69b66b"></path></g></svg>
    `;
}
